(() => {
  if (window.__lioraAccessibilityLoaded) return;
  window.__lioraAccessibilityLoaded = true;

  const enhance = (root = document) => {
    root.querySelectorAll('button[name="minus"], button[aria-label="minus"], button[aria-label="button-minus"]').forEach((button) => {
      button.setAttribute('aria-label', 'Decrease quantity');
    });

    root.querySelectorAll('button[name="plus"], button[aria-label="plus"], button[aria-label="button-plus"]').forEach((button) => {
      button.setAttribute('aria-label', 'Increase quantity');
    });

    root.querySelectorAll('button[aria-label="button-remove"]').forEach((button) => {
      button.setAttribute('aria-label', 'Remove item from cart');
    });

    root.querySelectorAll('button[aria-label="image-thumbnai"]').forEach((button) => {
      const image = button.querySelector('img');
      const description = image?.getAttribute('alt')?.trim();
      button.setAttribute('aria-label', description ? 'View image: ' + description : 'View product image');
    });

    root.querySelectorAll('.variant-selects-main input[type="radio"] + label[tabindex]').forEach((label) => {
      label.removeAttribute('tabindex');
    });

    root.querySelectorAll('.variant-selects-main fieldset.product-form__input[data-option-name="color"]').forEach((fieldset) => {
      if (!fieldset.querySelector('.color-watches')) return;

      fieldset.querySelectorAll('input.input-radio[data-available]').forEach((input) => {
        const value = input.value.trim();
        const state = input.dataset.available === 'true' ? 'available' : 'currently unavailable';
        const accessibleName = value + ' — ' + state;
        input.setAttribute('aria-label', accessibleName);
        input.labels?.[0]?.setAttribute('aria-label', accessibleName);
      });

      const hasUnavailable = fieldset.querySelector('input.input-radio[data-available="false"]');
      let backSoonKey = fieldset.querySelector('.liora-back-soon-key');

      if (hasUnavailable && !backSoonKey) {
        const legend = fieldset.querySelector('legend');
        const legendRow = legend?.parentElement;

        if (legendRow?.parentElement === fieldset) {
          backSoonKey = document.createElement('div');
          backSoonKey.className = 'liora-back-soon-key';

          const badge = document.createElement('span');
          badge.className = 'liora-back-soon-badge';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = 'BACK\nSOON';

          const note = document.createElement('span');
          note.className = 'liora-back-soon-note';
          note.textContent = 'Select a Back Soon color, then click Notify Me for a restock alert.';

          backSoonKey.append(badge, note);
          legendRow.insertAdjacentElement('afterend', backSoonKey);
        }
      } else if (!hasUnavailable && backSoonKey) {
        backSoonKey.remove();
      }

    });
  };

  const scheduleEnhancement = (() => {
    let scheduled = false;
    return () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        enhance();
      });
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }

  new MutationObserver(scheduleEnhancement).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
